import { el } from './dom';

/** Renders the canonical response text as a plain, readable paragraph — textContent only, never innerHTML. */
export function renderText(container: HTMLElement, text: string): void {
  container.append(el({ tag: 'p', className: 'kia-text', text }));
}
